import { render, staticRenderFns } from "./AdBanners.vue?vue&type=template&id=6ab70b62&"
import script from "./AdBanners.vue?vue&type=script&lang=js&"
export * from "./AdBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports